// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

type Props = PageProps;

interface RecommandeProductRequestStyles {
    page?: MobiusPageProps;
}

const recommandeProductRequestStyles: RecommandeProductRequestStyles = {};

const styles = recommandeProductRequestStyles;

const RecommandeProductRequestPage = ({ id }: Props) => {
    return (
        <Page data-test-selector="alternatePackagingRequest" {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: RecommandeProductRequestPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;
